export const GroupConversationList=(messages) => {
    return {
      type:"Group_Conversation_List",
      messages,
      segmentName: "groupConversationList",
    }
}